import { NpsPieMerchantCreateDto } from './nps-pie-merchant-create.dto';
import { NpsSurveyDto } from './nps-survey.dto';

export class NpsDto {
  id?: number;
  npsSurveyId: number;
  pieBrandId: number;
  name: string;
  description: string;
  keyTerm: string;
  npsLink?: string;
  npsUrl?: string;
  startDate?: Date;
  endDate?: Date;
  isActive?: boolean;
  isOnline?: boolean;
  isFollowUpEnabled?: boolean;
  survey?: NpsSurveyDto;
  merchants?: NpsPieMerchantCreateDto[];
  createdDate?: Date;
  modifiedDate?: Date;
}
